(function (Translator) {
    // en
    Translator.add("theme.dropzone.drop-files-here", "Drag the files here to upload", "DropZone", "en");
    Translator.add("theme.dropzone.max-file-size", "The maximum file size is %maxFileSize%", "DropZone", "en");
    Translator.add("theme.dropzone.max-number-of-files", "The maximum number of files is %maxNumberOfFiles%", "DropZone", "en");
    Translator.add("theme.dropzone.not_allowed_file_mime_type", "This file does not allow the MIME type", "DropZone", "en");
    Translator.add("theme.dropzone.or", "or", "DropZone", "en");
    Translator.add("theme.dropzone.overall-max-file-size", "The file size must not exceed %maxFilesSize%", "DropZone", "en");
    Translator.add("theme.dropzone.select_file", "Select a file", "DropZone", "en");
    Translator.add("theme.dropzone.selected_files", "Valid files imported", "DropZone", "en");
    Translator.add("theme.dropzone.selected_files_with_errors", "Invalid files", "DropZone", "en");
    Translator.add("theme.dropzone.selected_transfer_serial_number_in_file", "Transfer a number in a file", "DropZone", "en");
    Translator.add("theme.dropzone.too_big_file", "This file is too large to import", "DropZone", "en");
})(Translator);
